import * as React from 'react';
import { WatchedShipment } from 'services/clients/watchList';
import { Cell } from './Cell';
import { CellProps } from './types';

export const ReferenceCell: React.FC<CellProps> = (props) => {
  const watch: WatchedShipment = props.row;
  return <Cell>{watch.customer?.code || '-'}</Cell>;
};
ReferenceCell.displayName = 'AddContainers.RecentlyAdded.Table.ReferenceCell';
